__turbopack_context__.v({
  "ButtonWrapper": "CustomerModalForm-module-scss-module__Hnuvqq__ButtonWrapper",
  "Form": "CustomerModalForm-module-scss-module__Hnuvqq__Form",
  "PrimaryButton": "CustomerModalForm-module-scss-module__Hnuvqq__PrimaryButton",
  "SecondaryButton": "CustomerModalForm-module-scss-module__Hnuvqq__SecondaryButton",
});
